import MapDirection from 'components/MapDirection';
import { FORMAT_DATE_FOR_DISPLAY, FORMAT_TIME } from 'constants/days';
import moment from 'moment';
import React from 'react';
import { metersToMiles } from 'utils';

import { INotaryAppointments } from '../types';

const NewAppointmentDetail: React.FC<{ notaryAppointment: INotaryAppointments }> = ({ notaryAppointment }) => {
  const { description, date, address, distance, price, duration } = notaryAppointment;
  const appointmentDate = moment(date).format(FORMAT_DATE_FOR_DISPLAY);
  const appointmentStartTime = moment(date).format(FORMAT_TIME).toString();
  const appointmentEndTime = moment(date)
    .add((duration || 0) / 3600, 'h')
    .format(FORMAT_TIME)
    .toString();
  const appointmentDuration = (duration || 0) / 3600;
  return (
    <div className='appointment-detail-container appointment-container'>
      <div className='appointment-info-section'>
        <div className='appointment-info'>
          <div className='appointment-description'>{description || 'Notary Appointment'}</div>
          <div className='appointment-day'>{appointmentDate}</div>
          <div className='appointment-time'>
            {appointmentStartTime} - {appointmentEndTime} ({appointmentDuration} hour)
          </div>
        </div>
        <div className='appointment-address'>
          <div>Address</div>
          <div className='appointment-address-street'>{address.address1}</div>
          <div className='appointment-address-city-state'>
            {address.city}, {address.state} {address.zip}
          </div>
        </div>
        <div className='appointment-distance'>
          <div className='gx-font-weight-bold'>Distance: </div>
          <div className='distance'>{metersToMiles(distance || 0).toFixed(1)} miles</div>
        </div>
        <div className='appointment-payout'>
          <div className='gx-font-weight-bold'>Payout: </div>
          <div className='price'>${price}</div>
        </div>
      </div>
      <div className='appointment-map-section'>
        <MapDirection location={address} style={{ height: '100%', width: '100%' }} />
      </div>
    </div>
  );
};
export default NewAppointmentDetail;
